import React, { Component } from 'react'
import ACCESS from 'utils/Access'
import LocationSearch from 'components/shared/LocationSearch'
import { Subsection, Row } from 'components/settings/UserProfile/Section'
import { Visibility } from 'app/modules/profile/constants'
import withNotifications from 'components/shared/notifications'
import cx from 'classnames'
import { PROFILE_DOMAIN } from 'constants/ResourcesConstants'
import './styles.styl'
import 'styles/components/settings/Settings.styl'
import { Icon, Input } from '@driftt/tide-core-legacy'
import { ToolTip, Toggle } from '@driftt/tide-core'

const HandleInput = ({ url, value, defaultValue, onChange, className }) => (
  <div className="HandleInput">
    <div className="HandleInput__InputContainer">
      <div className={cx('HandleInput__URL', className)}>{url}</div>
      <Input
        size="small"
        value={value}
        placeholder="your personal handle"
        defaultValue={defaultValue}
        onChange={onChange}
      />
    </div>
  </div>
)

class OverviewInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      inputs: this.getProfileState(),
      showAdvanced: false,
    }
  }

  getProfileState = () => {
    const { profile } = this.props
    return {
      handleInput: profile.handle,
      globalHandleInput: profile.globalHandle,
      jobTitleInput: profile.jobTitle,
      locationInput: profile.location,
      locationLat: profile.lat,
      locationLong: profile.lng,
      quoteInput: profile.quote,
    }
  }

  handleToggleAdvanced = () => {
    this.setState({ showAdvanced: !this.state.showAdvanced })
  }

  handleBioChange = event => {
    const { value } = event.target
    this.setState({ inputs: { ...this.state.inputs, quoteInput: value }})
  }

  handleTitleChange = event => {
    const { value } = event.target
    this.setState({ inputs: { ...this.state.inputs, jobTitleInput: value }})
  }

  handleLocationChange = suggestion => {
    const {
      label,
      location: { lat, lng },
    } = suggestion
    this.setState({
      inputs: {
        ...this.state.inputs,
        locationInput: label,
        locationLat: lat,
        locationLong: lng,
      },
    })
  }

  selectDefault = () => {
    const defaultSelection = {
      label: '',
      location: { lat: 0, lng: 0 },
    }
    this.handleLocationChange(defaultSelection)
  }

  handleChangeHandle = event => {
    const handle = event.target.value
      .trim()
      .toLowerCase()
      .replace(/([^a-z0-9\-])+/g, '') // trim all non-hyphen alphanumeric
    this.setState({ inputs: { ...this.state.inputs, handleInput: handle }})
    if (handle.length > 0) {
      this.props.actions.checkUserHandle(handle)
    }
  }

  handleChangeGlobalHandle = event => {
    const globalHandle = event.target.value
      .trim()
      .toLowerCase()
      .replace(/([^a-z0-9\-])+/g, '') // trim all non-hyphen alphanumeric
    this.setState({ inputs: { ...this.state.inputs, globalHandleInput: globalHandle }})
    if (globalHandle.length > 0) {
      this.props.actions.checkGlobalUserHandle(globalHandle)
    }
  }

  handleVisibilityChange = event => {
    const value = event.target.checked ? Visibility.PUBLIC : Visibility.PRIVATE
    this.props.actions.setVisibility(value)
    this.props.actions.track('Profile Visibility Changed', { value })
  }

  handleSave = () => {
    const { actions, globalHandle, handle } = this.props
    const {
      inputs: {
        quoteInput,
        jobTitleInput,
        handleInput,
        globalHandleInput,
        locationInput,
        locationLat,
        locationLong,
      },
    } = this.state
    const profilePayload = {
      quote: quoteInput,
      jobTitle: jobTitleInput,
      location: locationInput,
      latitude: locationLat,
      longitude: locationLong,
    }
    _.map(profilePayload, (value, key) => value !== undefined && actions.setProfileUIData({ key, value }))
    if (!!globalHandleInput && globalHandleInput !== globalHandle) {
      actions.setProfileUIData({ key: 'globalHandle', value: globalHandleInput })
    }
    if (!!handleInput && handleInput !== handle) {
      actions.setProfileUIData({ key: 'handle', value: handleInput })
    }
    actions.updateOverview()
  }

  handleCancel = () => {
    this.setState({
      inputs: this.getProfileState(),
    })
  }

  canSubmit = () => {
    const initialProfileState = this.getProfileState()
    const { isGlobalHandleValid, isHandleValid } = this.props
    const {
      inputs: { globalHandleInput, handleInput },
    } = this.state // are handles taken?
    const changes = _.filter(this.state.inputs, (value, key) => value !== initialProfileState[key])
    const invalidCharsInHandles =
      /([^a-z0-9\-])+/.test(globalHandleInput) || /([^a-z0-9\-])+/.test(handleInput)
    return changes.length > 0 && !invalidCharsInHandles && isGlobalHandleValid && isHandleValid
  }

  render() {
    const {
      globalHandle,
      handle,
      visibility,
      companyUrl,
      globalHandleCheckComplete,
      profileUpdateStatusPending,
      isGlobalHandleValid,
      isHandleValid,
    } = this.props

    const {
      showAdvanced,
      inputs: { globalHandleInput, handleInput, jobTitleInput, locationInput, quoteInput },
    } = this.state

    const hideAdvancedLink = ACCESS.hasGates('hide_company_handle')

    // globalHandle
    const showBlankError = !!globalHandle && globalHandleInput === ''
    const globalHasInvalidChars = /([^a-z0-9\-])+/.test(globalHandleInput)
    const isGlobalHandleTaken =
      !isGlobalHandleValid &&
      globalHandleCheckComplete &&
      globalHandleInput !== globalHandle &&
      globalHandleInput !== ''

    // handle
    const isHandleBlank = handleInput === ''
    const isHandleTaken = !isHandleValid && handleInput !== handle

    const showGlobalHandleUrl =
      !globalHasInvalidChars && !isGlobalHandleTaken && !!globalHandleInput && globalHandleInput !== ''

    return (
      <Subsection
      
        isValid={true}
        canSubmit={this.canSubmit()}
        onSubmit={this.handleSave}
        onCancel={this.handleCancel}
        loading={profileUpdateStatusPending}
        innerClassName="settings-overview-section"
      >
        <Row>
          <div className="settings-section-row-inner">
            <div className="settings-overview-setting-title">
              Your Drift Profile link{' '}
              <div className="profiles-settings-helptext-hover">
                <ToolTip
                  component={<div>Your Drift Profile link may only contain <br/> lowercase letters, numbers and hyphens.</div>}
                  tethered="true"
                  flow="up"
                >
                  <Icon name="info" />
                </ToolTip>
              </div>
            </div>
            <div key={`${globalHandle}-${handle}`} className="handle-input-container">
              <HandleInput
                size="small"
                url={PROFILE_DOMAIN}
                value={globalHandleInput}
                onChange={this.handleChangeGlobalHandle}
                defaultValue={globalHandleInput}
              />
              <div
                className={cx('handle-preview', {
                  error: showBlankError || globalHasInvalidChars || isGlobalHandleTaken,
                })}
              >
                <div>
                  {isGlobalHandleTaken && `this handle is taken`}
                  {showGlobalHandleUrl &&
                    globalHandleInput && (
                      <span>
                        Share your unique link:{' '}
                        <a href={`https://${PROFILE_DOMAIN}/${globalHandleInput}`}>
                          {PROFILE_DOMAIN}/{globalHandleInput}
                        </a>
                      </span>
                    )}
                  {showBlankError && `personal handle may not be blank`}
                  {globalHasInvalidChars && `Your handle may only contain letters and numbers.`}
                </div>
              </div>
              {/([^a-z0-9\-])+/.test(handle) && (
                <div style={{ marginTop: '1em' }}>
                  <HandleInput
                    size="small"
                    className="long-url"
                    url={companyUrl}
                    value={handleInput}
                    onChange={this.handleChangeHandle}
                    defaultValue={handleInput}
                  />
                  {/([^a-z0-9\-])+/.test(handleInput) && (
                    <div className="handle-preview error">
                      Your handle may only contain letters and numbers.
                    </div>
                  )}
                  {isHandleTaken && <div className="handle-preview error">This handle is taken.</div>}
                  {isHandleBlank && <div className="handle-preview error">handle cannot be blank.</div>}
                </div>
              )}
            </div>
          </div>

          <div className="settings-section-row-inner">
            <div className="settings-overview-setting-title">Allow others to see your Drift Profile</div>
            <div className="flex-space-between">
              <div>Ready to share your profile? Just turn this on.</div>
              <Toggle
                defaultChecked={visibility === Visibility.PUBLIC}
                onChange={this.handleVisibilityChange}
              />
            </div>
          </div>
        </Row>

        <Row>
          <div className="settings-section-row-inner">
            <div className="settings-overview-setting-title">Title</div>
            <Input
              type="text"
              size="small"
              placeholder="Job Title"
              onChange={this.handleTitleChange}
              isValid={true}
              value={jobTitleInput}
            />
            <div className="settings-overview-setting-title settings-overview-location">Location</div>
            <LocationSearch
              placeholder="Your location"
              initialValue={locationInput}
              types={['(cities)']}
              onSuggestSelect={this.handleLocationChange}
              selectDefault={this.selectDefault}
            />
          </div>

          <div className="settings-section-row-inner">
            <div className="settings-overview-setting-title">Short bio</div>
            <textarea
              className={cx("tide-textarea", "settings-profile-bio-text-area")}
              value={quoteInput}
              onChange={this.handleBioChange}
              isValid={true}
            />
            <div className="settings-overview-setting-title">Give a quick intro about who you are. Use this area to share your pronouns, interests outside of work, or even a fun fact!</div>
          </div>
        </Row>
      </Subsection>
    )
  }
}

export default withNotifications(OverviewInfo)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Sections/Profile/OverviewInfo/index.js